import * as Actions from '../actions.helpers'

export type InferValueTypes<T> = T extends { [key: string]: infer U }
  ? U
  : never

export const setToState =
  <Type extends string, State>(type: Type, defaultState: State) =>
  <Value extends State[keyof State]>(
    stat: keyof State,
    value: Value,
    isPending = false
  ) =>
    Actions.createPayloadAction(type, { stat, value, isPending })

export const changeState =
  <Type extends string, State>(type: Type, defaultState?: State) =>
  <Values extends Partial<State & { isPending: boolean }>>(state: Values) =>
    Actions.createPayloadAction(type, { ...state })

export const cleanerState =
  <Type extends string, State>(type: Type, defaultState?: State) =>
  (stat: keyof State) =>
    Actions.createPayloadAction(type, { stat })
